import { render, staticRenderFns } from "./ArtworkImportModal.vue?vue&type=template&id=38244353&scoped=true"
import script from "./ArtworkImportModal.vue?vue&type=script&lang=js"
export * from "./ArtworkImportModal.vue?vue&type=script&lang=js"
import style0 from "./ArtworkImportModal.vue?vue&type=style&index=0&id=38244353&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38244353",
  null
  
)

export default component.exports